<template>
    <div class="checkbox toggle" :class="[theme, {'active': active, 'disabled': disabled, 'wrap': wrap}]">
        <label v-for="(item, index) in data" :data-value="item.displayValue || item.value" v-ga:clickable="item.value" :class="{'checked': checked(item.value)}" :key="index">
            <input type="checkbox" :value="item.value" :disabled="item.disabled" :checked="checked(item.value, item.defaultValue)" @change="changed"/>
            <i></i>
            <span v-html="item.text"></span>
        </label>
    </div>
</template>
<script src="./mvt-checkbox.js"></script>

<style lang="scss">
@use "./mvt-checkbox.scss" as *;
</style>
